import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlagSe = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	id: "flag-icons-se",
	viewBox: "0 0 640 480",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#005293",
		d: "M0 0h640v480H0z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#fecb00",
		d: "M176 0v192H0v96h176v192h96V288h368v-96H272V0z"
	})]
});
export default SvgFlagSe;
